import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export default function CustomDocumentUploader({
  module,
  uploadedFiles,
  handleFileChange,
  isEditable,
}) {
  // current file (if any)
  const file = uploadedFiles[module.id];

  return (
    <Box marginY={2}>
      <Typography variant="subtitle1">
        {module.label || "Upload your own document"}
      </Typography>

      {file ? (
        <Typography variant="body2" sx={{ mb: 1 }}>
          📄 {file.name}
        </Typography>
      ) : (
        <Typography variant="caption" color="textSecondary" sx={{ mb: 1 }}>
          No file uploaded
        </Typography>
      )}

      {isEditable && (
        <Button
          variant="outlined"
          startIcon={<CloudUploadIcon />}
          component="label"
        >
          {file ? "Change File" : "Upload File"}
          <input
            type="file"
            hidden
            onChange={(e) =>
              e.target.files[0] &&
              handleFileChange(module.id, e.target.files[0])
            }
          />
        </Button>
      )}
    </Box>
  );
}
